import cookiePolicyURL from './config/cookiePolicy';

const ElmNav = document.getElementById('navright');
const fromLiraLog = window.navigator.userAgent.toLocaleLowerCase().includes('liralog');
const closeNavRight = () => ElmNav.style.width = '0px';

const openNavRight = () => ElmNav.style.width = '30%';

const showMainCopyright = () =>
  document.getElementById('maincopyright').style.display = 'flex';

const showLiraLogCopyright = () =>
  document.getElementById('liralogcopyright').style.display = 'block';

const toggleNavRight = () => {
  const navWidth = ElmNav.style.width;
  navWidth && navWidth !== '0px' ? closeNavRight(): openNavRight();
};

const setFullCookiePolicy = () => {
  document.getElementById('policyCookies').style.height = '100%';  
  document.getElementById('policyCookies')
    .src = `${cookiePolicyURL}?lastText=true&hiddenLogo=true`; 
};

const closeMainPopUp = () =>
  document.getElementById('mainpopup').style.display = 'none'; 

const setMainPopStyleToLiraLog = () => {
  document.getElementById('mainpopup').style.fontSize = '12px';  
  document.getElementById('acceptbtn').style.height = '25px';  
};

const openMainPopUp = () =>{
  if(fromLiraLog) setMainPopStyleToLiraLog();
  document.getElementById('mainpopup').style.display = 'flex';  
};

const closeSecondaryPopUp = () => 
  document.getElementById('secondarypopup').style.display = 'none';
  
const acceptCookiePolicy = () => localStorage.setItem('acceptedPolicy', true);

const getCookiePolicy = () => localStorage.getItem('acceptedPolicy');

const setWidthToLiraLog = () => {
  document.querySelector('#mainpopup').style.width = '76%';
  const center = document.querySelector('.center');
  //to compensate like horizontal bars of liralog
  center.style.height = '445px';
  center.style.minHeight = '445px';
  center.style.margin = '5px auto';
};

document.querySelector('#policybtn').addEventListener('click', () => {
  if(fromLiraLog){
    window.open(cookiePolicyURL);
  } else {
    toggleNavRight();
    closeMainPopUp();
  }
});

document.querySelector('#acceptbtn').addEventListener('click', () => {
  acceptCookiePolicy();
  closeMainPopUp();
});

document.querySelector('#cookiesPolicy').addEventListener('click', () => {
  const navWidth = ElmNav.style.width;
  toggleNavRight();
  closeMainPopUp();
  if(!getCookiePolicy() && navWidth && navWidth !== '0px' 
    && window.location.pathname !== '/grant')
    openMainPopUp();
  if(getCookiePolicy() && navWidth !== '30%' ) {
    closeSecondaryPopUp();
    setFullCookiePolicy();
  }
});

document.querySelector('#acceptsecondarybtn').addEventListener('click', () => {
  acceptCookiePolicy();
  closeNavRight();
  closeMainPopUp();  
});

document.querySelector('#btnClose').addEventListener('click', () => {
  closeNavRight();
  if(!getCookiePolicy() && window.location.pathname !== '/grant')
    openMainPopUp();  
});

const resolveInitialPolicy = () => {
  if(!fromLiraLog)
    showMainCopyright();
  else
    showLiraLogCopyright();
  if(!getCookiePolicy() && window.location.pathname !== '/grant'){
    if(fromLiraLog)
      setWidthToLiraLog();
    openMainPopUp();
  }
    
};

window.onload = resolveInitialPolicy;